<template>
  <div v-if="isIbtStepper">
    <el-progress type="dashboard" :percentage="percentage" color="#0051ff" :stroke-width="4" />
  </div>
  <div v-else class="registerProgressWrap">
    <el-progress class="registerProgress" type="dashboard" :percentage="percentage" color="#0051ff" :stroke-width="4" />
    <div class="progressText">
      <div>{{ $t('verificationStatus.regisetrProgress.estimatedTime') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegisterProgress',
  props: {
    percentage: { type: Number, required: true },
    isIbtStepper: { type: Boolean, default: false }
  }
};
</script>

<style lang="scss" scoped>
.registerProgressWrap {
  text-align: center;
  margin-bottom: 30px;
  .progressText {
    color: #0051ff;
    width: 70%;
    margin: 0 auto;
    font-size: 12px;
    line-height: 18px;
  }
}
.registerProgress /deep/ .el-progress__text {
  font-family: Inter;
  font-size: 36px !important;
  color: $primary-blue;
}
</style>
